import React from 'react';
import { useSelector } from 'react-redux';
import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import { safeExtractFromObject } from '../../helpers/helpers';
import OnTraccrButton from '../buttons/OnTraccrButton';
import Colors from '../../constants/Colors';

export default function CardGridFilterDrawerButton({
  filterActive,
  onFilterOpen,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  let filterButtonType = filterActive ? 'back' : 'primary';
  if (hasRedesign) {
    filterButtonType = filterActive ? 'primary' : 'cancel';
  }
  if (!onFilterOpen) return null;

  const baseStyle = { width: 32, height: 32 };
  const style = filterActive
    ? { ...baseStyle, backgroundColor: 'rgba(214, 233, 255, 0.7)', border: `1px solid ${Colors.BLUE_300}` }
    : baseStyle;

  const iconStyle = hasRedesign ? { marginLeft: -7, color: Colors.GRAY_800 } : { marginLeft: 0 };

  return (
    <OnTraccrButton
      title=""
      icon={
        filterActive
          ? <FilterFilled style={iconStyle} />
          : <FilterOutlined style={iconStyle} />
        }
      onClick={onFilterOpen}
      style={hasRedesign ? style : {}}
      type={filterButtonType}
    />
  );
}

CardGridFilterDrawerButton.propTypes = {
  filterActive: PropTypes.bool,
  onFilterOpen: PropTypes.func,
};

CardGridFilterDrawerButton.defaultProps = {
  filterActive: false,
  onFilterOpen: null,
};